import { Row, Col, Form, Input, Select } from "antd";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SelectArrow from "../../../../components/selectArrow";
import SelectBorder from "../../../../components/select";
import styles from "./style.module.scss";
import "./antCustomStyle.scss";
import {
  userRoles as rolesC,
  genres as genreC,
} from "../../../../assets/constants";
import { imageToBase64 } from "../../../../helpers.js/images";
import settingsActions from "../../../../redux/settings/actions";

const Details = () => {
  const [form] = Form.useForm();
  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
  }));
  const dispatch = useDispatch();
  const [showAddRole, setShowAddRole] = useState(false);
  const [showAddGenre, setShowAddGenre] = useState(false);
  const [roles, setRoles] = useState(rolesC);
  const [genres, setGenres] = useState(genreC);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedGenres, setSelectedGenres] = useState([]);
  const [profileImage, setProfileImage] = useState(currentUser?.profileImageUrl);
  const [profileImagePreview, setProfileImagePreview] = useState(
    currentUser?.profileImageUrl
  );
  const [coverImage, setCoverImage] = useState(currentUser.coverImageUrl);
  const [coverImagePreview, setCoverImagePreview] = useState(
    currentUser.coverImageUrl
  );
  const [status, setChangeStatus] = useState();

  useEffect(() => {
    const setRolesAndGenres = () => {
      if (currentUser.role) {
        const rls = currentUser.role.split(",");
        for (const rl of rls) {
          onSelectRole(rl);
        }
      }
      if (currentUser.genre) {
        const rls = currentUser.genre.split(",");
        for (let i = 0; i < rls.length; i++) {
          onSelectGenre(rls[i])
        }
      }
    }
    setRolesAndGenres()
  }, [selectedRoles, selectedGenres]);

  const onFinish = (values) => {
    const st = values.newStatus
      ? `${values.status} ${values.newStatus}`
      : values.status;
    delete values.status;
    delete values.newStatus;
    dispatch({
      type: settingsActions.UPDATE_USER_DETAILS,
      payload: {
        ...values,
        status: st,
        role: selectedRoles.length > 0 ? selectedRoles.join() : "",
        genre: selectedGenres.length > 0 ? selectedGenres.join() : "",
        profileImage:
          profileImage === currentUser?.profileImageUrl ? null : profileImage,
        coverImage:
          coverImage === currentUser.coverImageUrl ? null : coverImage,
      },
    });
  };

  const onSelectRole = (value) => {
    const index = roles.findIndex((r) => r === value);
    if (selectedRoles.length >= 3 || index < 0) {
      return;
    }
    setSelectedRoles([...selectedRoles, roles[index]]);
    const newRoles = [...roles];
    newRoles.splice(index, 1);
    setRoles(newRoles);
    setShowAddRole(false);
    return true;
  };

  const onSelectGenre = (value) => {
    const index = genres.findIndex((r) => r === value);
    if (selectedGenres.length >= 3 || index < 0) {
      return;
    }
    setSelectedGenres([...selectedGenres, genres[index]]);
    const newGenres = [...genres];
    newGenres.splice(index, 1);
    setGenres(newGenres);
    setShowAddGenre(false);
    return true;
  };

  const onChangeProfileImage = async (e) => {
    if (e.target.files.length === 1) {
      const file = e.target.files[0];
      if (3 < file.size / 1024 / 1024) {
        return;
      }
      const preview = await imageToBase64(file);
      setProfileImage(file);
      setProfileImagePreview(preview);
    }
  };

  const onChangeCoverImage = async (e) => {
    if (e.target.files.length === 1) {
      const file = e.target.files[0];
      if (3 < file.size / 1024 / 1024) {
        return;
      }
      const preview = await imageToBase64(file);
      setCoverImage(file);
      setCoverImagePreview(preview);
    }
  };

  return (
    <div className={styles.detailsContainer}>
      <Form
        name="about-you-form"
        onFinish={onFinish}
        requiredMark={false}
        initialValues={currentUser}
      >
        <div className={styles.genericButton}>
          <button className={styles.button} htmlType="submit">
            Save
          </button>
        </div>
        <div className={styles.mainContent}>
          <Row justify="space-between" align="top" className={styles.pictures}>
            <Col span={11}>
              <div className={styles.title}>Profile Picture</div>
              <div className={styles.uploadImages}>
                <div
                  className={styles.thumb}
                  style={
                    profileImagePreview
                      ? {
                          backgroundImage: `url(${profileImagePreview})`,
                        }
                      : {}
                  }
                />
                <div className={styles.uploadButton}>
                  <label htmlFor="profilePicture">Upload new photo</label>
                  <input
                    id="profilePicture"
                    type="file"
                    accept="image/*"
                    onChange={onChangeProfileImage}
                  />
                  <span>Image format with max 3mb</span>
                </div>
                <div className={styles.removeButton}>
                  <button
                    onClick={() => {
                      setProfileImagePreview(null);
                      setProfileImage(null);
                    }}
                  >
                    Remove
                  </button>
                </div>
              </div>
            </Col>
            <Col span={11}>
              <div className={styles.title}>Cover Image</div>
              <div className={styles.uploadImages}>
                <div
                  className={styles.thumb}
                  style={
                    coverImagePreview
                      ? { backgroundImage: `url(${coverImagePreview})` }
                      : {}
                  }
                />
                <div className={styles.uploadButton}>
                  <label htmlFor="coverPicture">Upload new photo</label>
                  <input
                    id="coverPicture"
                    type="file"
                    accept="image/*"
                    onChange={onChangeCoverImage}
                  />
                  <span>Image format with max 3mb</span>
                </div>
                <div className={styles.removeButton}>
                  <button
                    onClick={() => {
                      setCoverImagePreview(null);
                      setCoverImage(null);
                    }}
                  >
                    Remove
                  </button>
                </div>
              </div>
            </Col>
          </Row>
          <div className={styles.form}>
            <div className={styles.roleContainer}>
              <label>Role</label>
              <div className={styles.listRoles}>
                {selectedRoles.map((role) => (
                  <div key={role} className={styles.role}>
                    {role}
                  </div>
                ))}
                {selectedRoles.length < 3 && (
                  <>
                    {!showAddRole ? (
                      <div className={styles.role}>
                        <div
                          className={styles.plus}
                          onClick={() => {
                            if (selectedRoles.length <= 3) {
                              setShowAddRole(true);
                            }
                          }}
                        >
                          +
                        </div>
                      </div>
                    ) : (
                      <div className={styles.selectrole}>
                        <SelectBorder options={roles} onSelect={onSelectRole} />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <Row justify="flex" className={styles.roleContainer}>
              <label>Genre</label>
              <div className={styles.listRoles}>
                {selectedGenres.map((genre) => (
                  <div key={genre} className={styles.genre}>
                    {genre}
                  </div>
                ))}
                {selectedGenres.length < 3 && (
                  <>
                    {!showAddGenre ? (
                      <div className={styles.genre}>
                        <div
                          className={styles.plus}
                          onClick={() => {
                            if (selectedGenres.length <= 3) {
                              setShowAddGenre(true);
                            }
                          }}
                        >
                          +
                        </div>
                      </div>
                    ) : (
                      <div className={styles.selectrole}>
                        <SelectBorder
                          options={genres}
                          onSelect={onSelectGenre}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </Row>
            <Form.Item name={"bio"} label="About">
              <Input.TextArea placeholder="Up to 180 Characters ..." rows={4} />
            </Form.Item>
            <Form.Item name={"location"} label="Location">
              <Input />
            </Form.Item>

            <Form.Item name={"status"} label="Status">
              <Select
                suffixIcon={SelectArrow}
                onChange={(v) => {
                  form.setFieldsValue({ newStatus: "" });
                  setChangeStatus(v);
                }}
              >
                <Select.Option value="Independent">Independent</Select.Option>
                <Select.Option value="Working At">Working At</Select.Option>
                <Select.Option value="Signed To">Signed To</Select.Option>
              </Select>
            </Form.Item>
            {(status === "Working At" || status === "Signed To") && (
              <Form.Item name={"newStatus"} label="Set Status">
                <Input />
              </Form.Item>
            )}
            <Row>
              <Col span={14}>
                <Form.Item name={"managementType"} label="Management">
                  <Select suffixIcon={SelectArrow}>
                    <Select.Option value="Manager">Manager</Select.Option>
                    <Select.Option value="Management">Management</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={7} className={styles.username}>
                <Form.Item name={"managementUser"} className={styles.username}>
                  <Input prefix={<span className={"username"}>@</span>} />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default Details;
